import { render } from "./headerimage.vue?vue&type=template&id=70d499d1&scoped=true"
import script from "./headerimage.vue?vue&type=script&lang=js"
export * from "./headerimage.vue?vue&type=script&lang=js"

import "./headerimage.vue?vue&type=style&index=0&id=70d499d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d499d1"]])

export default __exports__